module.exports = __webpack_public_path__ + "img/screenshot_1.818daa83.jpg";